module.exports = __webpack_public_path__ + "media/Video 95b.803273bd.mp4";